import React, { useState, useEffect } from "react";
import { history } from "../../helpers";
import { connect } from "react-redux";
import { userActions } from "../../actions";

function ForgotPassword(props) {
  const { login, logout, authentication, requestPasswordReset } = props;

  const [email, setEmail] = useState("");

  useEffect(() => {
    logout();
  }, []);

  const handleEmailChange = (e) => {
    const { name, value } = e.target;
    setEmail(value);
  };

  const submitRequest = (e) => {
    e.preventDefault();
    requestPasswordReset(email);
    history.replace("/login?status=pwd_reset_requested");
  };

  return (
    <>
      <div class="login">
        <span class="pwdMessage">
          Enter your email address below. We'll email you a link to reset your
          password.
        </span>
        <br />
        <br />
        <form class="ingestorForm">
          <table class="ingestorFormTable">
            <tr>
              <td class="formLabel">
                <label for="limit">Email:</label>
              </td>
              <td class="formInfo">
                <input
                  type="text"
                  name="groupName"
                  id="groupName"
                  onChange={handleEmailChange}
                ></input>
              </td>
            </tr>
            <tr>
              <td class="formLabel">&nbsp;</td>
              <td class="formInfo">
                <button class="submit" onClick={submitRequest}>
                  Submit
                </button>
              </td>
            </tr>
          </table>
        </form>
      </div>
    </>
  );
}

function mapStateToProps(state) {
  const { authentication } = state;
  return {
    authentication,
  };
}

const actionCreators = {
  login: userActions.login,
  logout: userActions.logout,
  requestPasswordReset: userActions.requestPasswordReset,
};

const connectedForgotPassword = connect(
  mapStateToProps,
  actionCreators
)(ForgotPassword);
export { connectedForgotPassword as ForgotPassword };
